import {
    IonPage, IonContent, IonAlert
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import cookieUtil from "../../../../utils/cookieUtil";
import { accountAppealPlanQueryByToken} from "./Service";
import Script from "react-load-script";
import {captchaKeFuAppId, captchaUrl} from "../../../../utils/common";


class AppealProgress extends Component {

    constructor(props) {
        super(props);

        this.state = {
            phone: '',
            phoneTip: 0,
            code: '',
            codeTip: null,
            agreementTip: true,
            scriptLoaded: false,
            showTipModal: false,
            getCodeMsg: "获取验证码",
            showNoticeTip: false,
            djs: '',
            result: [],
            token: null,

        }
    }

    regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)
    regCode = new RegExp(/^[0-9]{6}$/)

    setPhone = (e) => {
        this.setState({phone: e, phoneTip: 0})
    }

    componentDidMount() {
        if (cookieUtil.has("access_token")) {
            this.setState({token: cookieUtil.get("access_token")})
        }
        if(cookieUtil.has("userInfo")){
            let userInfoJson = JSON.parse(cookieUtil.get("userInfo"))
            //console.log(userInfoJson);
            this.setState({account: userInfoJson.userGameId})
        }
    }


    checkPhone = () => {
        const {phone} = this.state;
        let phoneTip = 0;
        if (!this.regPhone.test(phone)) {
            phoneTip = 1;
        }
        console.log('phoneTip====' + phoneTip)
        this.setState({
            phoneTip: phoneTip,
        })

    };

    setCode = (e) => {
        let codeTip = 0;
        if (this.regCode.test(e)) {
            codeTip = 1
        }

        this.setState({
            code: e,
            codeTip: codeTip
        })
    }

    queryAppealResult = () => {
        const {phone, phoneTip, account, token} = this.state;

        if (token === null) {
            this.setState({isShowTip: true, showTipMsg: '请重新登录'})
            return
        }

        if (phone == "" || phoneTip === 1) {
            this.setState({isShowTip: true, showTipMsg: '手机号码格式不正确，请重新输入'})
            return
        }

        const _that = this;

        // eslint-disable-next-line
        let captcha1 = new TencentCaptcha(captchaKeFuAppId(), function (res) {
            console.log(res)
            if (res.ret === 0) {

                const params = {
                    'phone': phone,
                    'accounts': account,
                    'access_token': token,
                    'qqNumber': '',
                    'ticket': res.ticket,
                    'randStr': res.randstr,
                };

                accountAppealPlanQueryByToken(params).then(ret => {
                    captcha1.destroy();
                    if (ret.code === '10000') {
                        _that.setState({
                            result: ret.data.list
                        })
                    } else {
                        _that.setState({
                            isShowTip: true,
                            showTipMsg: ret.msg
                        })
                    }
                }).catch(err => {
                    console.log(err);
                    captcha1.destroy();
                });
            }
        }, {bizState: 'RSCNO7XFNGG9r6xB'});

        captcha1.show(); // 显示验证码

    }

    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null
        })
    }

    getAppealTypeMsg = (type) => {
        if (type === 1) {
            return "解除绑定手机"
        } else if (type === 2) {
            return "解除绑定微信"
        } else if (type === 3) {
            return "重置保险箱密码"
        } else if (type === 4) {
            return "其它问题"
        }
    }

    render() {

        const {result} = this.state;

        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="sut_cont bggray">
                        <div className="phone_top pr border-bottom-e6">
                            <div className="top_title">申诉进度</div>
                        </div>
                        <div className="cont_kf">
                            <Script
                                url={captchaUrl()}
                                onError={this.handleScriptError}
                                onLoad={this.handleScriptLoad}
                            />
                            <div className="phone_input_box">
                                <div className="phone_identity clearfix ">
                                    <span className="w246">游戏账号或者ID</span>
                                    <input type="text" className="input-tex4" placeholder="申诉填写游戏账号或游戏ID" value={this.state.account}
                                           onChange={e => this.setState({account: e.target.value})}/>
                                </div>
                                <div className="phone_identity clearfix">
                                    <span className="w246">手机号码</span>
                                    <input type="text" className="input-tex4" placeholder="申诉时所填写手机号码"
                                           onChange={e => this.setState({phone: e.target.value})}
                                           onBlur={() => this.checkPhone()}/>
                                </div>
                                <a className="btn_kf mt100" onClick={this.queryAppealResult}>查看申诉结果</a>
                            </div>
                            {/*<!------------申诉进度3种结果----------------->*/}
                            {result.length > 0 && result.map((v,index)=>{
                                    return (
                                        <div className={v.appealState > 0 ? "results_box_kefu" : "dn"}>
                                            {v.appealState === 1
                                                ? <div className="results_img"><img
                                                    src={require("../../../images/member/kefu/phone/successful_img.jpg")}/></div>
                                                : v.appealState === 2
                                                    ? <div className="results_img"><img
                                                        src={require("../../../images/member/kefu/phone/proces_img.jpg")}/></div>
                                                    : <div className="results_img"><img
                                                        src={require("../../../images/member/kefu/phone/failure_img.jpg")}/></div>}
                                            <div className="resu_cont-kefu">
                                                <p><em>申诉类型：</em>{v.appealType}</p>
                                                <p><em>申诉状态：</em>{v.appealState === 1
                                                    ? <span className="cg_tex">申诉成功</span>
                                                    : v.appealState === 2
                                                        ? <span className="cl_tex">申诉处理中</span> :
                                                        <span className="sb_tex">申诉失败</span>} </p>
                                                {v.appealResult !== '' ?
                                                    <p><em>申诉处理结果：</em>{v.appealResult}</p> : ''}
                                                <p><em>申诉处理时间：</em><i className="textGrey9">{v.handleTime}</i></p>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(AppealProgress);
